export const WORKSUITE_IDENTITY_CLIENT = Object.freeze({
  clientId: String(process.env.REACT_APP_CLIKKLE_AUTH_CLIENT_ID || "").trim(),
  displayName: "Clikkle Chat",
  protocolVersion: "2",
  accountsUrl: process.env.REACT_APP_LOGIN_DOMAIN || "https://accounts.clikkle.com",
});

export const AUTH_STORAGE_KEYS = Object.freeze([
  "user",
  "token",
  "refreshToken",
  "sessionToken",
]);

export const AUTH_COOKIE_KEYS = Object.freeze([
  "accessToken",
  "refreshToken",
  "userId",
  "fullName",
  "role",
]);

export const AUTH_QUERY_KEYS = Object.freeze([
  "userId",
  "accessToken",
  "token",
  "refreshToken",
  "sessionToken",
  "identity_error",
  "error",
  "error_description",
]);

export const INTENDED_ROUTE_KEY = "chat.identity.intendedRoute";
export const AUTH_TRANSACTION_KEY = "clikkle.accounts.identityTransaction";
